import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';


import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';


import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewProcess from "../components/ViewProcess";
import ViewMetadata from "../components/ViewMetadata";

import ListProcesses from "../components/ListProcesses";
import ListSteps from "../components/ListSteps";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewProcessVersion from "../components/ViewProcessVersion";

import Rendition from '../components/Rendition';


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';
import Buffering from "../components/Buffering";

import {getProcess, addProcess, editProcess} from '../utils/utilsProcess';



class Process extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
        };


        this.data = {};
//        this.viz = null;
//        this.vizEngine = "neato";


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);
        this.loadedSteps = this.loadedSteps.bind(this);



        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/processes`;


    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        // Handle route/props changes
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadProcess(id){

        if (id === undefined || id === null){
            return;
        }

        this.setState({ renderState: 'loading' });

        // Main process load
        const onLoad = function(Process) {
            let StateChange = {
                Process: Process,
                isLoaded: true,
                renderState: 'loaded'
            };

            if (this.context.hasLayout){
                this.context.Layout.setLeftAsProcess(Process._id);
            }

            StateChange.FormData = Process;
            StateChange.OfferEdit = false;
            
            if (this.dsd.loggedon){
                if (this.dsd.user.id === Process.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            this.setState(StateChange, () => {

                // Set up breadcrumb navigation
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'process'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
                window.Breadcrumb.push(['process',`/process/${id}`]);

                this.FallBackNavigation = `../processes`;
                this.onUpdateNavigation = this.FallBackNavigation;
            });

            // Fetch DOT from server
            this.fetchViz(id);

        }.bind(this);

        const onFail = function(e) {
            if (e.response){
                if (e.response.status === 403){
                    this.setState({
                        renderState: 'denied',
                        errorMessage: 'Access Denied'
                    });
                } else {
                    this.setState({
                        renderState: 'failed',
                        errorMessage: e.message || 'Failed to load process'
                    });
                }
            } else {
                this.setState({
                    renderState: 'failed',
                    errorMessage: e.message || 'Failed to load process'
                });
            }
        }.bind(this);

        getProcess(this.dsd, id, onLoad, onFail);
        
        return;
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getProcess(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };


    setup(){


        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            renderState: 'loading',
            errorMessage: '',

            OfferEdit: false,

            FormData: {},
            Controls: {
            },

            idProcess : null,
            countSteps : null,

            Process: null,
            idVersion: null,

            dot: null,

            action: null,

            updateToggle: 0,

            countVersions: null

        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idProcess = getParam('id', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        // For new mode, set as loaded immediately
        if (StateChange.mode === 'new'){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        // If viewing a version, mark as loaded so version component displays
        if (StateChange.idVersion){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        if (StateChange.idProcess){
            this.loadProcess(StateChange.idProcess);
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case 'vizArtefacts':
            case 'vizSwimlanes':
                let Controls = this.state.Controls;
                Controls[FormFieldName] = FormFieldValue;        
                this.setState({"Controls": Controls});
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':
                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/process/${this.state.idProcess}`);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false
                })

                const onError = function(e){
                    console.error('Error saving process:', e);
                    this.setState({
                        isFailed: true,
                        errorMessage: e.message || 'Failed to save process'
                    });
                }.bind(this);
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(id){
                            this.props.navigation(`/process/${id}`);
                        }.bind(this);
                        
                        addProcess(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/process/${this.state.idProcess}`);
                        }.bind(this);
                        
                        editProcess(this.dsd, this.state.idProcess, this.state.FormData, onUpdate, onError);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };


        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddStep':
                this.props.navigation(`/process/${this.state.idProcess}/step?mode=new`);
                break;
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    handleAddVersion(event) {

        this.setState({newVersion:true});

    }


    handleClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'step':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/step/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'artefact':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/artefact/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };


    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.Process){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idProcess} type='process' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idProcess}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
        this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    loadedSteps(count){

        let StateChange = {};

        StateChange.countSteps = 0;
        if (count){
            StateChange.countSteps = count;
        }

        this.setState(StateChange);

    }

    visualise(){
    
        if (!this.state.Process){
            return null;
        }

        const onChangeVizControl = function(event){

            const FormFieldName = event.target.name;
            let FormFieldValue = event.target.value;

            if (event.target.type == "checkbox"){
                FormFieldValue = event.target.checked;
            }

            let Controls = this.state.Controls;
            Controls[FormFieldName] = FormFieldValue;
            this.setState({Controls:Controls}, () => {
                this.fetchViz(this.state.idProcess);
            });
        }.bind(this);


        try {

            return(
                <div>
                    <table>
                        <tr>
                            <td>
                                Swimlanes <input type="checkbox" name="vizSwimlanes" onChange={onChangeVizControl}  checked={this.state.Controls.vizSwimlanes}/>
                            </td>
                            <td>
                                Artefacts <input type="checkbox" name="vizArtefacts" onChange={onChangeVizControl}  checked={this.state.Controls.vizArtefacts}/>
                            </td>
                        </tr>
                    </table>

                    <div name="divProcessMap" onClick={this.handleClick}>
                        <D3Graphviz dot={this.state.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        // Handle loading/error states
        if (this.state.mode === 'view'){
            switch(this.state.renderState){
                case 'loading':
                    return <Buffering />;
                case 'failed':
                    return (
                        <div>
                            <PD.ErrorBox>Error: {this.state.errorMessage}</PD.ErrorBox>
                        </div>
                    );
                case 'denied':
                    return (
                        <div>
                            <PD.ErrorBox>Access Denied</PD.ErrorBox>
                        </div>
                    );
                default:
                    break;
            }
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };

        if (this.state.isLoaded || this.state.mode === 'new') {

            if (this.state.idVersion){
                return(
                    <ViewProcessVersion idVersion={this.state.idVersion} idProcess={this.state.idProcess}/>
                )
            }

/*
            let boolOfferEdit = false;

            if (this.state.Process){
                this.state.FormData = this.state.Process;
                if (this.dsd.loggedon){
                    if (this.dsd.user.id == this.state.Process.idUser){
                        boolOfferEdit = true;
                    }
                }        
            }
*/

            switch (this.state.mode){
                case 'new':
                case 'edit':

                    return (
                    <div>

                        <PD.Heading>{this.state.mode} Process</PD.Heading>
    
                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }
    
                        <form> 
                            <PD.Input label="Name" width="30" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                            <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                            <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ProcessStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Process</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewProcess json={this.state.Process}/>
                        </div>
                    )
                case 'view':
                default:

                    if (!this.state.Process){
                        return <div/>
                    }
                    
                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Process:{this.state.Process.name}</PD.Heading>
                            </div>

                            {this.state.OfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                </span>
                            }

                            <ViewProcess Process={this.state.Process}/>

                            <br/>

                            <PD.Tabs>

                                <div label='Visualise'>
                                    {this.visualise()}
                                </div>


                                <div label={<span>Steps({this.state.countSteps === null ? <Buffering/> : this.state.countSteps})</span>} data-forcerender="true">

                                    {!this.state.action && this.state.OfferEdit &&                           
                                        <PD.Button name='btnAddStep' value='add a new Step' onClick={this.handleButton}/>
                                    }
                                    
                                    <ListSteps filters={{idProcess:this.state.idProcess}} parent={this} onLoad={this.loadedSteps} />
                                
                                </div>


                                <div label="used in ...">
                                    <ListProcesses filters={{idSubProcess:this.state.idProcess}} columns={{"owner":true}}/>
                                </div>

                                {this.state.idProcess &&
                                    <div label='Publication'>
                                        <PD.PdNavLink to={`/viewer/process/${this.state.idProcess}`} >Default Publication View</PD.PdNavLink>
                                    </div>
                                }

                                <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                    {this.versions()}
                                </div>


                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/processes"
                                        id={this.state.idProcess}
                                    />
                                </div>


                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.Process} />
                                </div>

                            </PD.Tabs>


                        </div>
                    )
            };
        };

        return <div />;
    };
};

// Wrap and export
export default function Process_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Process {...props} navigation={navigation} location={location} params={params} />;
  }
